module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-3-d97dd1e1f2dba5ebaebf6dd7bf271097.png";